<template>
	<slide-up @close="() => closePop()" :show="showNewGoal">
		<div class="px-4 flex flex-col min-h-[80vh]">
			<div class="flex-1">
				<input type="text" v-model="newGoal.title" placeholder="New Goal" class="text-2xl" />

				<div class="mt-8">
					<div ref="goalDescription" :contenteditable="true" class="text-base"
						@input="(e) => newGoal.description = e.target.innerText" placeholder="Description"></div>
				</div>

				<div class="form-group mt-8">
					<legend>Tasks</legend>

					<div>
						<div class="flex items-center mb-2" v-for="(task, n) in newGoal.tasks || []" :key="n">
							<button class="ml-1 mr-2 flex items-center justify-center">
								<span class="block w-5 h-5 border-[1.5px] border-gray-1  rounded-full"></span>
							</button>

							<input type="text" placeholder="Task Name" v-model="task.task_name" class="w-full">
						</div>

						<button class="flex items-center text-sm ml-px" @click="() => addTask()">
							<church-icon class="!text-black mr-2" icon="plus-circle-solid"></church-icon> Add Task
						</button>
					</div>
				</div>

				<div class="form-group mt-8">
					<legend>Assigned Users</legend>

					<div>
						<m-search-user :users="modifiedUsers" @selected="(user) => newGoal.assigned_users = [...newGoal?.assigned_users || [], user]"/>

						<m-assigned-user-list :users="newGoal?.assigned_users || []" @removeUser="(user) => removeUserFromList(user)" />

					</div>
				</div>
			</div>

			<button :disabled="disableCreateBtn" @click="() => createNewGoal()"
				class="btn-secondary my-4 !bg-black disabled:!bg-gray-1">
				<span 
                  v-if="isCreating"
                  class="loader"></span>

				<span v-else>
					Create
				</span>
			</button>
		</div>
	</slide-up>
</template>

<script setup>
/* =========== UTILS ======== */
import GoalApi from "@/apis/goalApis"
import store from "@/store"
import { computed, ref, defineProps, defineEmits, onBeforeMount } from "vue"

/* ========== PROPS ====== */
const props = defineProps({
	showNewGoal : {type : Boolean, default : () => false},
	users : {type : Array, default : () => []},
})



/* ========== STATES ====== */
const newGoal = ref({tasks : [], author : null,  assigned_users : []})
const isCreating    = ref(false)
const goalDescription = ref(null)



/* ========= EMITS ======== */
const emit = defineEmits(['close'])


/* ========== COMPUTED ====== */

/**
 * Disable create btn by condition
 */
 const disableCreateBtn = computed(() => {
    console.log('newGoalnewGoal', newGoal.value)

    if(!newGoal.value?.title) return true
    if(!newGoal.value?.description) return true
	if(newGoal.value?.tasks?.length == 0) return true
	if(newGoal.value?.tasks?.filter(t=> !t.task_name)?.length > 0) return true;
	// if(newGoal?.value?.assigned_users?.length == 0) return true
    if(isCreating.value) return true
    
    return false;
})


/**
 * Current user
 */
const currentUser = computed(() => store.state.user.user_info || null)


/**
 * Modified users
 * removed added users from the list
 */
const modifiedUsers = computed(() => {
	return props.users.filter(user => !newGoal.value?.assigned_users?.find(u => u.ID == user.ID))
})


/* ========= METHODS ======= */

/**
 * Remove user from list
 * @param {Object} user
 */
const removeUserFromList = (user) => {
	newGoal.value = {...newGoal.value, assigned_users : newGoal.value?.assigned_users?.filter(u => u.ID != user.ID)}
}


/**
 * Add more tasks
 */
const addTask = () => {
	newGoal.value  = {...newGoal.value, tasks : [...newGoal?.value?.tasks, {
		task_name : ''
	}]}
}

/**
 * Close slide -up
 */
const closePop = () => {
	// console.log('closing pop')
	newGoal.value = {tasks : [], author : currentUser.value?.ID, title : '', description : '',  assigned_users : []}
	isCreating.value = false
	if(goalDescription.value) goalDescription.value.innerText = ''
	emit('close')
}


/**
 *  creating new goal
 */
 const createNewGoal = async () => {
	isCreating.value = true
	let assigned_users = newGoal.value?.assigned_users?.map(user => user.ID);

	if(assigned_users?.length == 0) {
		assigned_users = [currentUser.value?.ID]
	}
	
	const params = {
		...newGoal.value,
		assigned_users,
		tasks : newGoal.value?.tasks?.map(task => task.task_name)
	}
    GoalApi.createNewGoal({params, callback : () => {
		setTimeout(() => {
			closePop()
		}, 1000);
	}})

}

/** =========== ONLOAD ========= */
onBeforeMount(() => {
	/* Set current user as author */
	newGoal.value = {...newGoal.value, author : currentUser.value?.ID}
})
</script>
